import { useEffect } from 'react';

// Third-party
import Container from '@mui/material/Container';

// Components
import { Tasklists } from '../features/tasklists';
import {
  DeleteTasklist,
  CreateEditTasklist,
} from '../features/tasklists/Tasklist/components';

// Hooks
import {
  useGetTasklistsAPI,
  useGetDailySubmissionsAPI,
  useGetSubmissionsAPI,
} from '../features/tasklists/Shared/hooks/api';

// Hooks
import { useAppDispatch, useAppSelector } from '../hooks/useAppStore';

// Redux-toolkit
import { tasklistsActions } from '../store/tasklists/slice';
import { getSelectedTasklist } from '../store/tasklists/selectors';

// Utils
import { getFormattedSubmissions } from '../features/tasklists/Shared/utils';
import { PAGES_ANALYTICS_TITLES } from '../utils/enums';
import { PageHelmet } from '../components';

const TasklistsPage = () => {
  const { data: tasklistsData } = useGetTasklistsAPI(true);
  const { data: dailySubmissionsData } = useGetDailySubmissionsAPI(true);
  const { data: submissionsData } = useGetSubmissionsAPI({
    isMainSubmissionsPage: true,
  });
  const selectedTasklist = useAppSelector(getSelectedTasklist);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (submissionsData?.submissions?.summary) {
      const formattedSubmissions = getFormattedSubmissions(submissionsData?.submissions?.summary);
      dispatch(tasklistsActions.setFormattedSubmissions(formattedSubmissions));
    }
    if (tasklistsData?.tasklists?.length && !selectedTasklist.id) {
      dispatch(tasklistsActions.setSelectedTasklist({ ...tasklistsData?.tasklists[0] }));
    }

    if (dailySubmissionsData?.submissions) {
      dispatch(tasklistsActions.setSelectedDailySubmission({ ...dailySubmissionsData?.submissions[0] }));
    }
  }, [tasklistsData?.tasklists,
    dailySubmissionsData?.submissions,
    submissionsData?.submissions]);

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.TASKLISTS}>
      <Container
        sx={{
          px: { xs: 1, lg: 2 },
        }}
        maxWidth={false}
      >
        <Tasklists />
        <DeleteTasklist />
        <CreateEditTasklist />
      </Container>
    </PageHelmet>
  );
};

export default TasklistsPage;
